import React from 'react';
import { useWindowSize } from 'src/hooks/useWindowSize';
import AssetLayer from 'src/components/AssetLayer';
import { SingleStepType } from '../types';
import { LARGE_BREAKPOINT } from 'src/components/modular-grid/constants';
import { openInPopup } from './utils';
import styles from './SingleStep.module.scss';

export interface SingleStepPropTypes {
  step: Omit<SingleStepType, 'hide_on'>;
  index?: number;
  onClick?: (args: { stepTitle: string }) => void;
}

const SingleStep: React.FC<SingleStepPropTypes> = ({
  step,
  index,
  onClick,
}) => {
  const { image, title, text, url } = step;
  const { width: windowWidth } = useWindowSize();
  const shouldOpenInModal = windowWidth > LARGE_BREAKPOINT.min;

  const handleOnClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (shouldOpenInModal) {
      e.preventDefault();
      url && openInPopup(url);
    }
    onClick && onClick({ stepTitle: step.title });
  };

  const getTitle = () =>
    `${index !== undefined ? `${index + 1}. ` : ''}${title}`;

  const stepSingleContent = (
    <>
      <div className={styles.icon}>
        <AssetLayer
          imageSrc={{
            normal: image.source,
          }}
          alt={image.alt}
          isLazy
          type="image"
          rounded="none"
          fallbackBackgroundColor="transparent"
        />
      </div>
      <div className={styles.title} data-testid="title">
        {getTitle()}
      </div>
      <div
        className={styles.text}
        data-testid="text"
        dangerouslySetInnerHTML={{
          __html: text,
        }}
      ></div>
    </>
  );

  const clickableStep = (
    <a
      className={styles.step}
      data-testid="step-link"
      target={'_blank'}
      rel={'noopener noreferrer'}
      href={url}
      onClick={handleOnClick}
    >
      {stepSingleContent}
    </a>
  );

  const nonClicableStep = (
    <div className={styles.step} data-testid="step-block">
      {stepSingleContent}
    </div>
  );

  return url ? clickableStep : nonClicableStep;
};

export default SingleStep;
